import {Alert, Snackbar} from '@mui/material';
import {alert_atom} from 'atoms';
import {get_inset_top} from 'common';
import {useEffect, useRef} from 'react';
import {useRecoilState} from 'recoil';
import {IAlertState} from 'types';

export default function ModalAlert() {
	const [alert, setAlert] = useRecoilState(alert_atom);
	const timerRef = useRef<NodeJS.Timeout | null>(null);

	useEffect(() => {
		if (alert.open) {
			if (timerRef.current) clearTimeout(timerRef.current);

			timerRef.current = setTimeout(() => {
				setAlert((prev: IAlertState) => ({...prev, open: false}));
				timerRef.current = null;
			}, 1500);
		}

		return () => {
			if (timerRef.current) {
				clearTimeout(timerRef.current);
				timerRef.current = null;
			}
		};
	}, [alert.open]);

	const handleClose = () => {
		setAlert((prev: IAlertState) => ({...prev, open: false}));
		if (timerRef.current) {
			clearTimeout(timerRef.current);
			timerRef.current = null;
		}
	};

	return (
		<Snackbar open={alert.open} anchorOrigin={{vertical: 'top', horizontal: 'center'}} sx={{marginTop: get_inset_top(), paddingTop: '16px'}}>
			<Alert severity={alert.severity} onClose={handleClose}>
				{alert.message}
			</Alert>
		</Snackbar>
	);
}
